import { FC } from 'react';
import { Link } from 'react-router-dom';

import Skeleton from '@mui/material/Skeleton';
import { AccountMenu } from 'src/presentations/components/molecules/accountMenu/AccountMenu';
import LogoImg from 'src/assets/images/new-logo-freya.svg';
import IconUser from 'src/assets/images/icons/user-white.svg';
import { cn } from 'src/utils/utility';
import { SentryDebug } from 'src/presentations/components/molecules/sentryDebug/SentryDebug';
import { useUserContext } from 'src/use-cases/user/userDetails';
import { Notification } from '../../molecules/notification/Notification';
import { NotificationSelector } from '../../molecules/notification/NotificationSelector';
import { ILandingTopWidgetProps } from './types';
import SearchBar from '../../molecules/searchBar';
import { UploadeButtonAction } from '../../molecules/uploadInvoice/ButtonAction';
import { useTourContext } from 'src/presentations/guided-tours';

export const LandingTopWidget: FC<ILandingTopWidgetProps> = (props) => {
  const { title, children, hideNotification, hideSearchBar, hideUploadButton } = props;

  const { userDetails, isLoading: isLoadingUserDetails } = useUserContext();

  const tour = useTourContext().appTour.registerTour('topWidget');

  return (
    <div className='flex items-center bg-[#1C2429] text-white  fixed z-[999] left-0 right-0'>
      <div className='flex items-center py-12 xl:py-18 px-20'>
        <Link id={tour.registerStep('logo')} to='/' className='flex items-center justify-center'>
          <img className='h-[36px]xl:h-auto' alt='tetrixx' src={LogoImg} />
        </Link>
      </div>

      <div className={cn('flex-1 flex items-center gap-24 py-12 xl:py-18 px-20', title && 'border-l border-[#2E363A]')}>
        {title && <div className='text-white text-18 font-medium p-0'>{title}</div>}
        <SentryDebug />
        <div className='ml-auto flex items-center gap-24'>
          <div className='flex items-center gap-8'>
            {children}
            {!hideUploadButton && <UploadeButtonAction id={tour.registerStep('uploadButton')} />}
            {!hideSearchBar && (
              <div id={tour.registerStep('searchBar')} className='w-[20rem]'>
                <SearchBar placeholder='Search by invoice/shipment number' onSubmit={() => {}} currentKeyword='' inputClassName='text-12 xl:text-14' />
              </div>
            )}
            {!hideNotification && (
              <NotificationSelector>
                <Notification id={tour.registerStep('notif')} />
              </NotificationSelector>
            )}
            <img src={IconUser} alt='' />
            <div className='flex flex-col gap-1 xl:gap-2'>
              {isLoadingUserDetails ? (
                <>
                  <Skeleton height={14} width='140px' sx={{ bgcolor: 'grey.100' }} />
                  <Skeleton height={14} width='90px' sx={{ bgcolor: 'grey.100' }} />
                </>
              ) : (
                <>
                  <p>
                    <strong className='block text-14 xl:text-16 text-white font-bold truncate max-w-[18rem]'>
                      {userDetails?.firstName} {userDetails?.lastName}
                    </strong>
                  </p>
                  <p className='text-12 xl:text-sm text-blue_grey-30'>{userDetails?.displayRole}</p>
                </>
              )}
            </div>
          </div>

          <AccountMenu id={tour.registerStep('userProfile')} />
        </div>
      </div>
    </div>
  );
};
